export default "__VITE_ASSET__Dt9NlpFv__"